import "core-js/modules/es6.string.starts-with";
import "core-js/modules/web.dom.iterable";
import _toConsumableArray from "/var/lib/jenkins/workspace/yesep-ui/node_modules/@babel/runtime-corejs2/helpers/esm/toConsumableArray.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { getAction } from '@/api/manage';
import { ChangeColMixin } from '@/mixins/ChangeColMixin1';
export default {
  name: 'warnDataModal',
  mixins: [ChangeColMixin],
  data: function data() {
    return {
      dataTitle: '',
      modalObj: {
        title: '',
        visible: false,
        st: 0,
        expandedRowKeys: [],
        columns: [{
          dataIndex: 'warnTime',
          colName: 'warn_time',
          title: '报警时间',
          align: 'center',
          sorter: true
        }, {
          dataIndex: 'factorName',
          colName: 'factor_name',
          title: '因子名称',
          align: 'center',
          sorter: true
        }, {
          dataIndex: 'factorVal',
          colName: 'factor_val',
          title: '监测数值',
          align: 'center',
          sorter: true
        }, {
          dataIndex: 'warnContent',
          colName: 'warn_content',
          title: '报警内容',
          align: 'center',
          sorter: true
        }, {
          dataIndex: 'warnStatus_dictText',
          colName: 'warn_status',
          title: '报警状态',
          align: 'center',
          sorter: true
        }],
        dataSource: []
      } //消息异常弹框

    };
  },
  mounted: function mounted() {
    console.log('headerNotice');
  },
  methods: {
    handleCancel: function handleCancel() {
      this.modalObj.visible = !this.modalObj.visible;
    },
    onToChangeData: function onToChangeData(data) {
      var _this = this;

      if (data.id) {
        getAction("/online/warn?order=desc&size=1&current=1&searchCount=false&id=".concat(data.id)).then(function (res) {
          if (res.success && res.result.records && res.result.records.length > 0) {
            data = res.result.records[0];
            _this.modalObj.title = "".concat(data.siteName, "(").concat(data.warnContent, ")");
            _this.modalObj.dataSource = [data];
            _this.modalObj.expandedRowKeys = [data.id];
            _this.modalObj.visible = true;
            _this.columns = [];
            _this.dataSource = [];

            if (data.msgId) {
              var objUrl = {
                "2011": {
                  title: "实时数据",
                  url: '/online/cn2011'
                },
                "2051": {
                  title: "分钟数据",
                  url: '/online/cn2051'
                },
                "2061": {
                  title: "小时数据",
                  url: "/online/st".concat(data.st, "/cn2061")
                }
              };
              _this.url = objUrl[data.cn] && objUrl[data.cn].url ? objUrl[data.cn].url : "/online/st".concat(data.st, "/cn").concat(data.cn ? data.cn : '2061');
              _this.dataTitle = objUrl[data.cn] && objUrl[data.cn].title ? objUrl[data.cn].title : '';
              _this.modalObj.st = data.st;
              _this.queryParam = {
                msgId: data.msgId,
                scopeId: data.siteId,
                scope: 1
              };

              _this.getCol(data.st);

              _this.loadData();
            }
          }
        });
      }
    },
    changeCol: function changeCol() {
      var _this2 = this;

      if (!this.columns.every(function (item) {
        return item.dataIndex != 'siteName';
      })) {
        this.columns = _toConsumableArray(this.cols);
        this.columns.splice(1, 0, this.siteColumn);
        this.allColumns.forEach(function (element) {
          _this2.columns.push(element);
        });
      } else {
        this.columns = _toConsumableArray(this.cols);
        this.allColumns.forEach(function (element) {
          _this2.columns.push(element);
        });
      }

      if (this.columns.length > 10) {
        console.log('this.$refs.colControl.selectCol.length', this.$refs.colControl.selectCol.length);
        console.log('this.fixedWidth', this.fixedWidth);
        this.scroll.x = this.cols.length * 100 + this.fixedWidth;
        this.cols.forEach(function (item) {
          item.fixed = 'left';
        });
        this.siteColumn.fixed = 'left';

        if (this.$refs.table) {
          console.log('this.scroll.x', this.scroll.x);
          console.log('this.scroll.x', this.$refs.table.$el.clientWidth);

          if (this.scroll.x <= this.$refs.table.$el.clientWidth) {
            this.scroll.x = false;
            this.cols.forEach(function (item) {
              item.fixed = false;
            });
          } else {
            this.scroll.x = this.cols.length * 100 + this.fixedWidth;
            this.cols.forEach(function (item) {
              item.fixed = 'left';
            });
          }
        }
      } else {
        this.scroll.x = false;
        this.cols.forEach(function (item) {
          item.fixed = false;
        });
        this.siteColumn.fixed = false;

        if (this.$refs.table) {
          if (this.scroll.x <= this.$refs.table.$el.clientWidth) {
            this.scroll.x = false;
            this.cols.forEach(function (item) {
              item.fixed = false;
            });
          } else {
            this.scroll.x = this.cols.length * 100 + this.fixedWidth;
            this.cols.forEach(function (item) {
              item.fixed = 'left';
            });
          }
        }
      }
    },
    loadData: function loadData(arg, updatePage) {
      var _this3 = this;

      var h = this.$createElement;
      this.queryParam.st = this.modalObj.st;
      this.loading = true;
      var that = this;

      if (arg === 1) {
        this.ipagination.current = 1;
      }

      if (this.isPagination) {
        this.queryParam.current = this.searchCount ? this.ipagination.current : this.queryParam.current;
        this.queryParam.size = this.searchCount ? this.ipagination.pageSize : this.queryParam.size;
        this.queryParam.searchCount = this.searchCount;
      }

      console.log('JSON.string', JSON.parse(JSON.stringify(this.cols)));
      getAction(this.url, this.queryParam).then(function (res) {
        if (res.success) {
          var showStandardState = true;

          if (_this3.modalObj.st.startsWith('2')) {
            showStandardState = res.result.records.some(function (item) {
              if (item.attrs.currentStandard) {
                return true;
              } else {
                return false;
              }
            });
          } else if (_this3.modalObj.st.startsWith('3') || _this3.modalObj.st.startsWith('5')) {
            showStandardState = res.result.records.some(function (item) {
              if (item.attrs.hasOwnProperty('currentStandard')) {
                return true;
              } else {
                return false;
              }
            });
          }

          console.log('showStandardState', showStandardState);

          _this3.getCol(_this3.modalObj.st, showStandardState);

          if (!updatePage) {
            if (_this3.queryParam.scope == 1) {
              if (res.result.query.factors.length + that.cols.length > 13) {
                that.cols.forEach(function (item) {
                  item.fixed = 'left';
                });
                that.siteColumn.fixed = 'left';
              } else {
                that.cols.forEach(function (item) {
                  item.fixed = false;
                });
                that.siteColumn.fixed = false;
              }
            } else {
              if (res.result.query.factors.length + that.cols.length > 12) {
                that.cols.forEach(function (item) {
                  item.fixed = 'left';
                });
                that.siteColumn.fixed = 'left';
              } else {
                that.cols.forEach(function (item) {
                  item.fixed = false;
                });
                that.siteColumn.fixed = false;
              }
            }

            that.allColumns = _toConsumableArray(that.cols);
            that.options = [];
          }

          if (that.isPagination) {
            that.dataSource = res.result.records;
            that.dataDetail = res.result.query;
            that.ipagination.total = res.result.total;

            if (!updatePage) {
              res.result.query.factors.forEach(function (element) {
                that.options.push({
                  label: element.title,
                  value: element.code,
                  categoryName: element.categoryName
                });
                that.allColumns.push({
                  code: element.code,
                  title: function title() {
                    return h("span", {
                      "style": "width:100%;word-break: break-all;"
                    }, [element.title, h("br"), h("span", {
                      "style": "color:red"
                    }, [_this3.handleTableHead(element)])]);
                  },
                  lastTitle: element.title,
                  align: 'center',
                  width: 100,
                  children: [{
                    title: element.unitName,
                    align: 'center',
                    width: 100,
                    dataIndex: element.code,
                    customRender: function customRender(text, record, index) {
                      return that.renderCol(element.code, text, record, element.title);
                    }
                  }]
                });
              });
              that.columns = _toConsumableArray(that.allColumns);

              if (that.queryParam.scope == '1') {
                that.spliceColumn(that.siteColumn);
                that.fixedWidth = 250;
              } else if (that.queryParam.scope == '2' || that.queryParam.scope == '3' || that.queryParam.scope == '4') {
                that.spliceColumn(that.siteColumn, 1);

                if (_this3.modalObj.st.startsWith('2') && that.dataSource.length > 0 && !that.dataSource[0]['attrs']['currentStandard']) {
                  that.fixedWidth = 365;
                } else {
                  that.fixedWidth = 450;
                }
              }

              if (_this3.modalObj.st.startsWith('2') && that.dataSource.length > 0 && !that.dataSource[0]['attrs']['currentStandard']) {
                for (var i = 0; i < that.columns.length; i++) {
                  if (that.columns[i]['title'] == '环境标准') {
                    that.columns.splice(i, 1);
                    break;
                  }
                }
              }

              if (that.columns.length > 10) {
                that.scroll.x = that.options.length * 100 + that.fixedWidth;
              } else {
                that.scroll.x = false;
              }
            }
          } else {
            that.dataSource = res.result.records;
            that.dataDetail = res.result.query;

            if (!updatePage) {
              res.result.query.factors.forEach(function (element) {
                that.options.push({
                  label: element.alias || element.title,
                  value: element.code,
                  categoryName: element.categoryName
                });
                that.allColumns.push({
                  code: element.code,
                  title: element.alias || element.title,
                  align: 'center',
                  width: 100,
                  children: [{
                    title: element.unitName,
                    align: 'center',
                    width: 100,
                    dataIndex: element.code,
                    customRender: function customRender(text, record, index) {
                      return that.renderCol(element.code, text, record, element.alias || element.title);
                    }
                  }]
                });
              });
              that.columns = _toConsumableArray(that.allColumns);

              if (!that.queryParam.scope && !that.queryParam.scopeId && that.queryParam.st) {
                that.spliceColumn(that.siteColumn, 1);
                that.fixedWidth = 365;
                _this3.scroll.y = 580;
              }

              if (that.columns.length > 13) {
                that.scroll.x = that.options.length * 100 + that.fixedWidth;
              } else {
                that.scroll.x = false;
              } // debugger
              // if(!that.queryParam.scope && !that.queryParam.scopeId && that.queryParam.st){
              //   that.scroll.x = that.options.length * 100 + that.fixedWidth
              // }


              _this3.$forceUpdate();
            }
          }
        } else {
          _this3.$message.warning('系统异常=>' + res.message);
        }

        if (_this3.$refs.colControl) _this3.$refs.colControl.firstState = true;
        console.log('queryParam', _this3.columns);
        console.log('queryParam', _this3.dataSource);
        _this3.loading = false;
        _this3.loadNum++;
      });
    }
  }
};